import React from 'react';
import useTranslation from '~/app/hooks/useTranslation';
import Input from '~/app/modules/form/Search/Input';
import { useStoreActions, useStoreState } from '~/store';
import classes from './style.module.scss';

export type IssueCategorySearchComponent = React.FC

const IssueCategorySearch: IssueCategorySearchComponent = () => {
  const { t } = useTranslation('issues');
  const searchText = useStoreState(state => state.issue.categorySearchText);
  const setCategorySearchText = useStoreActions(actions => actions.issue.setCategorySearchText);

  return (
    <Input
      placeholder={t('searchCategory')}
      className={classes['field']}
      inputClassName={classes['input']}
      onSearch={setCategorySearchText}
      value={searchText}
      iconPosition='left'
    />
  );
};

export default IssueCategorySearch
